/**
 * Simple Supabase client - no custom fetch, no retries, just works.
 */
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://kjbzzypfbxwrtiodjgjx.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtqYnp6eXBmYnh3cnRpb2RqZ2p4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwMTUyNDEsImV4cCI6MjA2NTU5MTI0MX0.dYF-COjhLslLxc-xCkgQ0LWwmKqRs19ckIt8NlmRdZ8";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});

// Exports for compatibility
export { SUPABASE_URL };
export const SUPABASE_PUBLISHABLE_KEY = SUPABASE_ANON_KEY;
export const checkSupabaseHealth = async () => true;
export const forceRefreshSession = async () => true;
export const safeSignOut = async () => supabase.auth.signOut();
